module.exports = __webpack_public_path__ + "static/media/undraw_personal_information_962o.cc0c0add.svg";